/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import RECOMMENDATION_PROPERTIES from 'constants/RECOMMENDATION_PROPERTIES';
import VisualizationPreviewList from 'lib/@waca/vis-recommender/src/js/preview/VisualizationPreviewList';
import { ProgressIndicator } from '@ba/ba-ui-carbon-toolkit';

import './CustomComparison.scss';

const CLASS_NAME = 'custom-comparison';

class CustomComparison extends Component {

	render() {
		return (
			<div className={CLASS_NAME}>
				<div className={CLASS_NAME + '__title'}>
					{StringResources.get('compareChooser_customComparison_title')}
				</div>
				<div className={CLASS_NAME + '__content'}>
					<div className={CLASS_NAME + '__common'}>
						<div className={CLASS_NAME + '__preview-list--horizontal'}>
							{this.renderContent()}
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderContent() {
		const { recommendationVM } = this.props;
		switch(recommendationVM.state) {
			case 'pending':
				return (
					<div className={CLASS_NAME + '__progress-indicator__container'}>
						<ProgressIndicator />
					</div>
				);
			case 'done':
				return this.renderList();
			case 'error':
				return (
					<div className={CLASS_NAME + '__error__container'}>
						{StringResources.get('error_cannot_load_recommended')}
					</div>
				);
		}
	}

	renderList() {
		const { recommendationVM } = this.props;
		const isNewLayoutEnabled = true;
		return (
			<VisualizationPreviewList
				items={recommendationVM.getRecommendations()}
				dashboardApi={this.props.dashboardApi}
				onClickItem={this._onClickItem}
				onAddItem={this.props.onItemAdded}
				additionalProperties={RECOMMENDATION_PROPERTIES}
				logger={this.props.logger}
				isNewLayoutEnabled={isNewLayoutEnabled}
				horizontal={true}
				noBottomTitle={true}
				itemSize={'medium'}
			/>
		);
	}

	_onClickItem = (item) => {
		this.props.onItemSelected(item);
	}
}

CustomComparison.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	logger: PropTypes.object.isRequired,
	recommendationVM: PropTypes.object.isRequired,
	onItemSelected: PropTypes.func,
	onItemAdded: PropTypes.func
};
CustomComparison.defaultProps = {
	onItemSelected: () => {}
};

export default CustomComparison;



// WEBPACK FOOTER //
// ./src/js/components/compareChooser/CustomComparison.js